import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  redeterminationSchema,
  redeterminationStatusEnumSchema,
  updateRedeterminationSchema,
} from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const redeterminationsContract = c.router({
  listRedeterminations: {
    summary: "Get a list of the current patient's redeterminations",
    method: "GET",
    path: "/redeterminations",
    query: z.object({
      status: z.array(redeterminationStatusEnumSchema).optional(),
    }),
    responses: {
      [HTTPStatusCode.OK]: z.array(redeterminationSchema),
    },
  },
  getRedetermination: {
    summary: "Get a specific redetermination by ID for the current patient",
    method: "GET",
    path: "/redeterminations/:redeterminationId",
    pathParams: z.object({
      redeterminationId: z.uuid(),
    }),
    responses: {
      [HTTPStatusCode.OK]: redeterminationSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
      [HTTPStatusCode.FORBIDDEN]: errorSchema,
    },
  },
  updateRedetermination: {
    summary: "Update an existing redetermination for the current patient",
    method: "PATCH",
    path: "/redeterminations/:id",
    pathParams: z.object({
      id: z.uuid(),
    }),
    body: updateRedeterminationSchema,
    responses: {
      [HTTPStatusCode.OK]: redeterminationSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
      [HTTPStatusCode.FORBIDDEN]: errorSchema,
      [HTTPStatusCode.INTERNAL_SERVER_ERROR]: errorSchema,
    },
  },
});
